import Vue from 'vue';
import ElementUI from './bootstrap';
import App from './App.vue';
import router from './router';
import store from './store';
import './app.css';
import './search-unified.css';
import './pagination-antd.css';
import './hub-pages.css';

Vue.config.productionTip = false;
Vue.use(ElementUI, {
    size: 'small'
});

new Vue({
    el: '#app',
    router,
    store,
    created: function () {
        if (this.$store.getters.isAuthenticated) {
            this.$store.dispatch('fetchCurrentUser').catch(function () {
            });
            this.$store.dispatch('fetchBranding').catch(function () {
            });
        }
    },
    render: function (h) {
        return h(App);
    }
});



// WEBPACK FOOTER //
// ./resources/assets/js/app.js